export const FLIGHT_NOT_AVAILABLE = 'FLIGHT_NOT_AVAILABLE'
export const ITINERARY_EXPIRED = 'ITINERARY_EXPIRED'
export const PRICE_CHANGED = 'PRICE_CHANGED'
export const PRICE_CHANGED_SEATSELL1 = 'PRICE_CHANGED_SEATSELL1'
export const isItineraryFNABlock = (status?: string): boolean => status === FLIGHT_NOT_AVAILABLE
